/* eslint-disable jsx-a11y/click-events-have-key-events */
import { AssetImage } from 'assets/images/AssetImage';
import cx from 'classnames';
import Typography, { TypographyColor } from 'components/typography/Typography';
import { TYPOGRAPHY_VARIANTS } from 'components/typography/typography-utils';
import { I18nNamespace } from 'constants/i18n.const';
import { useSoundContext } from 'context/SoundContext';
import { useNewPhotoLifeCycleStep } from 'hooks/useNewPhotoLifeCycleStep';
import { useTranslation } from 'hooks/useTranslation';
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  resetSelfeAppStateAction,
  setSelfeAppStateAction,
} from 'store/features/app/selfeAppSlice';
import { useAppDispatch, useAppSelector } from 'store/store-hooks';
import { v4 as uuidv4 } from 'uuid';
import './printing-start-page.css';

function PrintingStartPage() {
  const { T } = useTranslation([I18nNamespace.COMMON, I18nNamespace.PAGE]);
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { audio } = useSoundContext();
  const { isVerticalScreen } = useAppSelector((s) => s.booth);
  const { getNextPath } = useNewPhotoLifeCycleStep();

  // handle select frame
  const handleSelectPaymentMethod = () => () => {
    audio?.playContinueClick?.();
    navigate(getNextPath() || '');
    dispatch(setSelfeAppStateAction({ transactionId: uuidv4() }));
  };

  useEffect(() => {
    dispatch(resetSelfeAppStateAction());
  }, [dispatch]);

  return (
    <>
      <div className="print-start-page">
        {!isVerticalScreen && (
          <div className="print-start-page__title page-title-wrapper">
            <Typography
              variant={TYPOGRAPHY_VARIANTS.H1}
              data-text={T(`${I18nNamespace.COMMON}:whatDoYouWantToPrint`)}
              className="page-title"
            >
              {T(`${I18nNamespace.COMMON}:whatDoYouWantToPrint`)}
            </Typography>
          </div>
        )}
        <div className="print-start-page__btn-group">
          <div className={cx('print-start-page__item')}>
            <button
              type="button"
              className="print-start-page__btn"
              onClick={handleSelectPaymentMethod()}
            >
              <Typography
                variant={TYPOGRAPHY_VARIANTS.H2}
                className="print-start-page__btn--title uppercase text-center font-semibold"
                color={TypographyColor.SECONDARY}
              >
                {T(`${I18nNamespace.COMMON}:printingPhoto`)}
              </Typography>
              <img
                className="print-start-page__mascot"
                src={AssetImage.PrintingPhoto}
                alt=""
              />
            </button>
          </div>
          <div
            className={cx(
              'print-start-page__item print-start-page__item--right',
            )}
          >
            <button
              type="button"
              className="print-start-page__btn"
              onClick={handleSelectPaymentMethod()}
            >
              <Typography
                variant={TYPOGRAPHY_VARIANTS.H2}
                className="print-start-page__btn--title uppercase text-center font-semibold"
                color={TypographyColor.SECONDARY}
              >
                {T(`${I18nNamespace.COMMON}:printPortrait`)}
              </Typography>
              <img
                className="print-start-page__mascot"
                src={AssetImage.PrintingPortrait}
                alt=""
              />
            </button>
          </div>
        </div>
      </div>
    </>
  );
}

export default PrintingStartPage;
